import client from "./client";

export const fetchProfile = (userId) => client.get(`/users/${userId}`).then((r) => r.data);

export const updateProfile = (userId, updates) =>
  client.put(`/users/${userId}`, updates).then((r) => r.data);
